<template>
  <zoom-center-transition>
    <div
      v-if="visible"
      class="inline-alert alert"
      :class="[alertType, alertIcon]"
    >
      <button
        type="button"
        aria-hidden="true"
        class="close"
        data-notify="dismiss"
        @click="close"
      >
        ×
      </button>
      <i data-notify="icon" class="material-icons" v-if="icon">{{ icon }}</i>
      <span data-notify="message" v-html="message"></span>
    </div>
  </zoom-center-transition>
</template>

<script>
import { ZoomCenterTransition } from "vue2-transitions";
export default {
  components: {
    ZoomCenterTransition
  },
  model: {
    prop: 'visible',
    event: "close"
  },
  props: {
    visible: Boolean,
    message: String,
    icon: String,
    type: {
      type: String,
      default: "info",
    },
  },
  computed: {
    alertIcon() {
      if (this.icon) {
        return "alert-with-icon"
      }
      return null;
    },
    alertType() {
      return `alert-${this.type}`;
    }
  },
  methods: {
    close() {
      this.$emit("close", false);
    }
  }
};
</script>

<style scoped>
.inline-alert.alert.alert-with-icon {
  margin-top: 10px;
  padding-left: 60px;
}
</style>